'use strict';

(function () {
  'use strict';

  angular.module('zp').directive('imagesonload', imageonload);

  /** @ngInject */
  function imageonload($window, $rootScope) {
    return {
      link: link,
      restrict: 'A',
      scope: {
        loadedCallback: '=?'
      }
    };

    function link(scope, element, attrs) {
      var images = element.find('img');
      var imagesLoaded = 0;
      images.bind('load', function () {
        imagesLoaded++;
        if (imagesLoaded === images.length && scope.loadedCallback) {
          scope.loadedCallback();
        }
      });
      images.bind('error', function () {
        imagesLoaded++;
      });
    }
  }
})();